// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: #1a5276;
  --color-secondary: #5b8fa8;
  --color-accent: #2e86c1;
  --color-bg: #060609;
  --color-surface: #0a0a10;
  --color-surface-light: #12121c;
  --color-border: #1e1e2e;
  --color-text: #e0e0e0;
  --color-text-dim: #888;
  --color-success: #27ae60;
  --color-danger: #e74c3c;
  --font-heading: 'Orbitron', sans-serif;
  --font-body: 'DM Sans', sans-serif;
  --font-data: 'JetBrains Mono', monospace;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-body);
  background: var(--color-bg);
  color: var(--color-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--color-bg);
}

::-webkit-scrollbar-thumb {
  background: var(--color-border);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,sCAAsC;EACtC,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[":root {\n  --color-primary: #1a5276;\n  --color-secondary: #5b8fa8;\n  --color-accent: #2e86c1;\n  --color-bg: #060609;\n  --color-surface: #0a0a10;\n  --color-surface-light: #12121c;\n  --color-border: #1e1e2e;\n  --color-text: #e0e0e0;\n  --color-text-dim: #888;\n  --color-success: #27ae60;\n  --color-danger: #e74c3c;\n  --font-heading: 'Orbitron', sans-serif;\n  --font-body: 'DM Sans', sans-serif;\n  --font-data: 'JetBrains Mono', monospace;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-body);\n  background: var(--color-bg);\n  color: var(--color-text);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--color-bg);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--color-border);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--color-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
